<div class="{{localService.selectedLanguageCode}}">
    <div class="row">
        <div class="col-md-7">
            <div class="row">
                <div class="col-6">
                    <ngx-select style="max-width:300px;" *ngIf="localService.countryCodes" [(ngModel)]="ctryId"
                        [optionValueField]="'key'" [optionTextField]="'v1'" [items]="localService.countryCodes"
                        (select)="onLoad()" [noAutoComplete]="true"
                        [disabled]="ctryId != '' && localService.countryCodes.length == 1">
                    </ngx-select>
                </div>
                <div class="col-6">
                    <ngx-select style="max-width:300px;" *ngIf="notificationTypes"
                        [(ngModel)]="selectedNotificationType" [optionValueField]="'key'" [optionTextField]="'value'"
                        [items]="notificationTypes" (select)="onLoad()" [noAutoComplete]="true"
                        [disabled]="true">
                    </ngx-select>
                </div>
            </div>
        </div>
        <div class="col-md-5">
            <div class="row">
                <div class="col-8">
                    <ngx-select style="max-width:300px;" *ngIf="communicationGatewayTypes"
                        [(ngModel)]="selectedCommunicationGatewayType" [optionValueField]="'key'"
                        [optionTextField]="'value'" [items]="communicationGatewayTypes" (select)="onLoad()"
                        [noAutoComplete]="true" [disabled]="communicationGatewayTypes.length == 1">
                    </ngx-select>
                </div>
                <div class="col-4">
                    <button type="button" class="btn btn-primary" style="width: 100%;"
                        (click)="onSave()">{{localService.languageContent.common.save}}</button>
                </div>
            </div>
        </div>
    </div>
    <div>
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}"
            style="line-height:40px;margin-top: 10px;">
            <div *ngFor="let item of items" class="row styled_row">
                <div class="col-md-7">
                    <span style="color: green;"
                        [ngClass]="localService.getLanguageCode(item.v2)">{{getContent(item.v2)}}</span>
                </div>
                <div class="col-md-5" style="text-align: right;">
                    <span>{{localService.getEquivalentTitleById(item.v2)}}</span>
                    <span class="en">&nbsp;({{localService.getLanguageCode(item.v2)}})&nbsp;:</span>
                    <input autocomplete="off" type="text" class="en" maxlength="50" style="width:calc(100% - 120px);max-width: 400px;"
                        [(ngModel)]="item.v1" placeholder="Template Id" title="Template Id" />
                </div>
            </div>
        </div>
    </div>
</div>